import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, e as esm, o as objectWithoutPropertiesLoose} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {T as Typography} from "../../common/index-6e985b71.js";
import {c as createSvgIcon_1} from "../../common/createSvgIcon-ee034812.js";
import _jsxRuntime from "react/jsx-runtime";
import {B as ButtonBase} from "../../common/index-ef2a811c.js";
import "../../common/capitalize-c580b26a.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/capitalize-0607751a.js";
import "../../common/useForkRef-b591be37.js";
import "../../common/useEventCallback-f6be53c8.js";
import "../../common/useIsFocusVisible-28d126d4.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
var MoreHoriz = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }), "MoreHoriz");
  exports.default = _default;
});
var BreadcrumbCollapsed_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _styled = interopRequireDefault(styled_1);
  var _MoreHoriz = interopRequireDefault(MoreHoriz);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const BreadcrumbCollapsedButton = (0, _styled.default)(_ButtonBase.default, {
    skipSx: true
  })(({
    theme
  }) => (0, _extends2.default)({
    display: "flex",
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5)
  }, theme.palette.mode === "light" ? {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[700]
  } : {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.grey[100]
  }, {
    borderRadius: 2,
    "&:hover, &:focus": (0, _extends2.default)({}, theme.palette.mode === "light" ? {
      backgroundColor: theme.palette.grey[200]
    } : {
      backgroundColor: theme.palette.grey[600]
    }),
    "&:active": (0, _extends2.default)({
      boxShadow: theme.shadows[0]
    }, theme.palette.mode === "light" ? {
      backgroundColor: (0, esm.emphasize)(theme.palette.grey[200], 0.12)
    } : {
      backgroundColor: (0, esm.emphasize)(theme.palette.grey[600], 0.12)
    })
  }));
  const BreadcrumbCollapsedIcon = (0, _styled.default)(_MoreHoriz.default)({
    width: 24,
    height: 16
  });
  function BreadcrumbCollapsed(props) {
    const ownerState = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedButton, (0, _extends2.default)({
        focusRipple: true
      }, props, {
        ownerState,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedIcon, {
          ownerState
        })
      }))
    });
  }
  var _default = BreadcrumbCollapsed;
  exports.default = _default;
});
var breadcrumbsClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getBreadcrumbsUtilityClass = getBreadcrumbsUtilityClass;
  function getBreadcrumbsUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiBreadcrumbs", slot);
  }
  const breadcrumbsClasses = (0, core.generateUtilityClasses)("MuiBreadcrumbs", ["root", "ol", "li", "separator"]);
  var _default = breadcrumbsClasses;
  exports.default = _default;
});
var Breadcrumbs_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _Typography = interopRequireDefault(Typography);
  var _BreadcrumbCollapsed = interopRequireDefault(BreadcrumbCollapsed_1);
  var _breadcrumbsClasses = _interopRequireWildcard(breadcrumbsClasses_1);
  const _excluded = ["children", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes
    } = ownerState;
    const slots = {
      root: ["root"],
      li: ["li"],
      ol: ["ol"],
      separator: ["separator"]
    };
    return (0, core.unstable_composeClasses)(slots, _breadcrumbsClasses.getBreadcrumbsUtilityClass, classes);
  };
  const BreadcrumbsRoot = (0, _styled.default)(_Typography.default, {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles) => {
      return [{
        [`& .${_breadcrumbsClasses.default.li}`]: styles.li
      }, styles.root];
    }
  })({});
  const BreadcrumbsOl = (0, _styled.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles) => styles.ol
  })({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
  });
  const BreadcrumbsSeparator = (0, _styled.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles) => styles.separator
  })({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
  });
  function insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index) => {
      if (index < items.length - 1) {
        acc = acc.concat(current, /* @__PURE__ */ (0, _jsxRuntime.jsx)(BreadcrumbsSeparator, {
          "aria-hidden": true,
          className,
          ownerState,
          children: separator
        }, `separator-${index}`));
      } else {
        acc.push(current);
      }
      return acc;
    }, []);
  }
  const Breadcrumbs2 = /* @__PURE__ */ React$1.forwardRef(function Breadcrumbs3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiBreadcrumbs"
    });
    const {
      children,
      className,
      component = "nav",
      expandText = "Show path",
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = "/"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const [expanded, setExpanded] = React$1.useState(false);
    const ownerState = (0, _extends2.default)({}, props, {
      component,
      expanded,
      expandText,
      itemsAfterCollapse,
      itemsBeforeCollapse,
      maxItems,
      separator
    });
    const classes = useUtilityClasses(ownerState);
    const listRef = React$1.useRef(null);
    const renderItemsBeforeAndAfter = (allItems2) => {
      const handleClickExpand = () => {
        setExpanded(true);
        const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
        if (focusable) {
          focusable.focus();
        }
      };
      if (itemsBeforeCollapse + itemsAfterCollapse >= allItems2.length) {
        return allItems2;
      }
      return [...allItems2.slice(0, itemsBeforeCollapse), /* @__PURE__ */ (0, _jsxRuntime.jsx)(_BreadcrumbCollapsed.default, {
        "aria-label": expandText,
        onClick: handleClickExpand
      }, "ellipsis"), ...allItems2.slice(allItems2.length - itemsAfterCollapse, allItems2.length)];
    };
    const allItems = React$1.Children.toArray(children).filter((child) => {
      return /* @__PURE__ */ React$1.isValidElement(child);
    }).map((child, index) => /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
      className: classes.li,
      children: child
    }, `child-${index}`));
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(BreadcrumbsRoot, (0, _extends2.default)({
      ref,
      component,
      color: "text.secondary",
      className: (0, _clsx.default)(classes.root, className),
      ownerState
    }, other, {
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(BreadcrumbsOl, {
        className: classes.ol,
        ref: listRef,
        ownerState,
        children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
      })
    }));
  });
  var _default = Breadcrumbs2;
  exports.default = _default;
});
var Breadcrumbs = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    breadcrumbsClasses: true
  };
  Object.defineProperty(exports, "breadcrumbsClasses", {
    enumerable: true,
    get: function() {
      return _breadcrumbsClasses.default;
    }
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Breadcrumbs.default;
    }
  });
  var _Breadcrumbs = interopRequireDefault(Breadcrumbs_1);
  var _breadcrumbsClasses = _interopRequireWildcard(breadcrumbsClasses_1);
  Object.keys(_breadcrumbsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _breadcrumbsClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _breadcrumbsClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Breadcrumbs);
export default __pika_web_default_export_for_treeshaking__;
